import { categoryConstants } from "@/_constants";
import { categoryService } from "@/_services/category.service";

const getCategoriesRequest = () => ({
  type: categoryConstants.GET_CATEGORIES_REQUEST
});

const getCategoriesSuccess = (categories) => ({
  type: categoryConstants.GET_CATEGORIES_SUCCESS,
  payload: categories
});

const getCategoriesFailure = (error) => ({
  type: categoryConstants.GET_CATEGORIES_FAILURE,
  payload: error
});

const getCategories = () => {
  return async (dispatch) => {
    try {
      dispatch(getCategoriesRequest());
      
      const response = await categoryService.getCategories();
      
      // Assuming your backend returns: { error: false, message: "Category list", data: [...] }
      if (response.data && !response.data.error) {
        dispatch(getCategoriesSuccess(response.data.data));
      } else {
        dispatch(getCategoriesFailure(response.data.message || 'Failed to fetch categories'));
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 
                          error.message || 
                          'Error while getting categories';
      dispatch(getCategoriesFailure(errorMessage));
    }
  };
};

export const categoryActions = {
  getCategories,
};